// Map marker + summary-card icon assets for the Deliveryman Tracking Report.
// Glyph geometry is Material Design (react-icons/md: Storefront, PlayArrow,
// SportsScore, Check), except the delivery trolley which is the in-house
// svg_tripcar.svg asset. Every icon is built once at module load into a
// data: URI — no network request, no per-render work.

const GLYPH_STORE =
  "M21.9 8.89l-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zm-2.99-3.9l1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01zM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5zM8.49 9.52L9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41a1.42 1.42 0 01-.33-1.07zm-4.45-.16L5.05 5h1.97l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17zM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5z";

const GLYPH_PLAY = "M8 5v14l11-7z";

const GLYPH_FLAG =
  "M11 6H9V4h2v2zm4-2h-2v2h2V4zM9 14h2v-2H9v2zm10-4V8h-2v2h2zm0 4v-2h-2v2h2zm-6 0h2v-2h-2v2zm6-10h-2v2h2V4zm-6 4V6h-2v2h2zm-6 2V8h2V6H7V4H5v16h2v-8h2v-2H7zm8 2h2v-2h-2v2zm-4-2v2h2v-2h-2zM9 8v2h2V8H9zm4 2h2V8h-2v2zm2-4v2h2V6h-2z";

const GLYPH_CHECK = "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z";

const GLYPH_REPLAY =
  "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z";

// In-house delivery trolley (svg_tripcar.svg) — drawn on a 40x40 grid.
const GLYPH_TROLLEY =
  "M12.6875 10.25C11.7559 10.25 11 11.0059 11 11.9375V13.625H9.3125C9.00312 13.625 8.75 13.8781 8.75 14.1875C8.75 14.4969 9.00312 14.75 9.3125 14.75H11H18.3125C18.6219 14.75 18.875 15.0031 18.875 15.3125C18.875 15.6219 18.6219 15.875 18.3125 15.875H11H10.4375C10.1281 15.875 9.875 16.1281 9.875 16.4375C9.875 16.7469 10.1281 17 10.4375 17H11H17.1875C17.4969 17 17.75 17.2531 17.75 17.5625C17.75 17.8719 17.4969 18.125 17.1875 18.125H11H9.3125C9.00312 18.125 8.75 18.3781 8.75 18.6875C8.75 18.9969 9.00312 19.25 9.3125 19.25H11H16.0625C16.3719 19.25 16.625 19.5031 16.625 19.8125C16.625 20.1219 16.3719 20.375 16.0625 20.375H11V24.875C11 26.7383 12.5117 28.25 14.375 28.25C16.2383 28.25 17.75 26.7383 17.75 24.875H22.25C22.25 26.7383 23.7617 28.25 25.625 28.25C27.4883 28.25 29 26.7383 29 24.875H30.125C30.7473 24.875 31.25 24.3723 31.25 23.75C31.25 23.1277 30.7473 22.625 30.125 22.625V20.375V19.25V18.5926C30.125 17.9949 29.8895 17.4219 29.4676 17L26.75 14.2824C26.3281 13.8605 25.7551 13.625 25.1574 13.625H23.375V11.9375C23.375 11.0059 22.6191 10.25 21.6875 10.25H12.6875ZM27.875 18.5926V19.25H23.375V15.875H25.1574L27.875 18.5926ZM14.375 23.1875C14.8226 23.1875 15.2518 23.3653 15.5682 23.6818C15.8847 23.9982 16.0625 24.4274 16.0625 24.875C16.0625 25.3226 15.8847 25.7518 15.5682 26.0682C15.2518 26.3847 14.8226 26.5625 14.375 26.5625C13.9274 26.5625 13.4982 26.3847 13.1818 26.0682C12.8653 25.7518 12.6875 25.3226 12.6875 24.875C12.6875 24.4274 12.8653 23.9982 13.1818 23.6818C13.4982 23.3653 13.9274 23.1875 14.375 23.1875ZM23.9375 24.875C23.9375 24.4274 24.1153 23.9982 24.4318 23.6818C24.7482 23.3653 25.1774 23.1875 25.625 23.1875C26.0726 23.1875 26.5018 23.3653 26.8182 23.6818C27.1347 23.9982 27.3125 24.4274 27.3125 24.875C27.3125 25.3226 27.1347 25.7518 26.8182 26.0682C26.5018 26.3847 26.0726 26.5625 25.625 26.5625C25.1774 26.5625 24.7482 26.3847 24.4318 26.0682C24.1153 25.7518 23.9375 25.3226 23.9375 24.875Z";

export const MARKER_COLOR_SHOP_VALID = "#188038";
export const MARKER_COLOR_SHOP_INVALID = "#EA4335";
export const MARKER_COLOR_SHOP_REVISIT = "#9333EA";
export const MARKER_COLOR_TRIP_START = "#1A73E8";
export const MARKER_COLOR_TRIP_END = "#3C4043";
export const MARKER_COLOR_TRIP_CONTINUE = "#F29900";

export const PIN_W = 32;
export const PIN_H = 44;
const PIN_SHAPE =
  "M16 0C7.716 0 1 6.716 1 15c0 10.5 15 29 15 29s15-18.5 15-29c0-8.284-6.716-15-15-15z";

const DROP_SHADOW =
  '<defs><filter id="s" x="-60%" y="-60%" width="220%" height="220%">' +
  '<feDropShadow dx="0" dy="1.2" stdDeviation="1.1" flood-color="#0b0b0b" flood-opacity="0.35"/>' +
  "</filter></defs>";

const encode = (svg) =>
  `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;

// Nested <svg> keeps its own viewBox, so the glyph scales without manual maths.
const placeGlyph = (path, color, cx, cy, size, viewBox = "0 0 24 24") =>
  `<svg x="${cx - size / 2}" y="${cy - size / 2}" width="${size}" height="${size}" viewBox="${viewBox}">` +
  `<path d="${path}" fill="${color}"/></svg>`;

// Colored teardrop pin + white disc + colored glyph.
function buildPin(color, glyph, { size = 15, viewBox } = {}) {
  return encode(
    `<svg xmlns="http://www.w3.org/2000/svg" width="${PIN_W}" height="${PIN_H}" viewBox="0 0 ${PIN_W} ${PIN_H}">` +
      DROP_SHADOW +
      `<path filter="url(#s)" d="${PIN_SHAPE}" fill="${color}"/>` +
      `<circle cx="16" cy="15" r="10.5" fill="#ffffff"/>` +
      placeGlyph(glyph, color, 16, 15, size, viewBox) +
      `</svg>`,
  );
}

// Flat circular badge for the Visit Summary stat cards.
function buildBadge(bgColor, glyph, glyphColor, size = 22) {
  return encode(
    `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">` +
      `<circle cx="20" cy="20" r="20" fill="${bgColor}"/>` +
      placeGlyph(glyph, glyphColor, 20, 20, size) +
      `</svg>`,
  );
}

export const SHOP_ICON_VALID_URL = buildPin(
  MARKER_COLOR_SHOP_VALID,
  GLYPH_STORE,
);
export const SHOP_ICON_INVALID_URL = buildPin(
  MARKER_COLOR_SHOP_INVALID,
  GLYPH_STORE,
);
export const SHOP_ICON_REVISIT_URL = buildPin(
  MARKER_COLOR_SHOP_REVISIT,
  GLYPH_REPLAY,
);
export const TRIP_START_ICON_URL = buildPin(
  MARKER_COLOR_TRIP_START,
  GLYPH_PLAY,
);
export const TRIP_END_ICON_URL = buildPin(MARKER_COLOR_TRIP_END, GLYPH_FLAG);
export const TRIP_CONTINUE_ICON_URL = buildPin(
  MARKER_COLOR_TRIP_CONTINUE,
  GLYPH_TROLLEY,
  { size: 17, viewBox: "0 0 40 40" },
);

export const VISITED_SHOPS_BADGE_URL = buildBadge(
  "#E8F5EC",
  GLYPH_CHECK,
  MARKER_COLOR_SHOP_VALID,
);
export const REMAINING_SHOPS_BADGE_URL = buildBadge(
  "#FDECEA",
  GLYPH_STORE,
  MARKER_COLOR_SHOP_INVALID,
  20,
);

export const MARKER_LEGEND_ITEMS = [
  { type: "tripStart", icon: TRIP_START_ICON_URL, label: "Trip Start" },
  { type: "shopValid", icon: SHOP_ICON_VALID_URL, label: "Visited Shop" },
  { type: "shopRevisit", icon: SHOP_ICON_REVISIT_URL, label: "Revisited Shop" },
  { type: "shopInvalid", icon: SHOP_ICON_INVALID_URL, label: "Visited Shop (Non-Inducted)" },
  { type: "tripContinue", icon: TRIP_CONTINUE_ICON_URL, label: "Trip Continued" },
  { type: "tripEnd", icon: TRIP_END_ICON_URL, label: "Trip End" },
];

export function getMarkerType(item) {
  if (item.timing?.startsWith("S")) return "tripStart";
  if (item.timing?.startsWith("E")) return "tripEnd";
  if (!item.vizShopId) return "tripContinue";
  if (item.isNonInducted) return "shopInvalid";
  return item.isRevisit ? "shopRevisit" : "shopValid";
}

const MARKER_ICON_URL_BY_TYPE = {
  tripStart: TRIP_START_ICON_URL,
  tripEnd: TRIP_END_ICON_URL,
  tripContinue: TRIP_CONTINUE_ICON_URL,
  shopInvalid: SHOP_ICON_INVALID_URL,
  shopRevisit: SHOP_ICON_REVISIT_URL,
  shopValid: SHOP_ICON_VALID_URL,
};

// google.maps.Size/Point are only safe to construct after the Maps API loads,
// so this is called during render rather than at module load.
export function getMarkerIcon(item) {
  return {
    url: MARKER_ICON_URL_BY_TYPE[getMarkerType(item)],
    scaledSize: new window.google.maps.Size(PIN_W, PIN_H),
    anchor: new window.google.maps.Point(PIN_W / 2, PIN_H),
  };
}
